/* LickSticks native cart drawer – no app calls, one request per action */
(() => {
  const cfg = window.LS_CART || {};
  const root = document.getElementById('ls-cart');
  if (!root) return;
  const $ = (s, el = root) => el.querySelector(s);
  const linesEl = $('[data-ls-cart-lines]');
  const emptyEl = $('[data-ls-cart-empty]');
  const totalEl = $('[data-ls-cart-total]');
  const countEl = $('[data-ls-cart-count]');
  const saveWrap = $('[data-ls-cart-save]');
  const saveEl = $('[data-ls-cart-saving]');
  const ups = $('[data-ls-ups]');
  const total2 = $('[data-ls-cart-total2]');
  const MAX_UPS = 3;
  const spToggle = $('[data-ls-sp-toggle]');
  const hidden = new Set((cfg.hidden || []).map(Number));
  let cart = cfg.initial || null;
  let busy = false;

  const money = (cents) => {
    const v = (cents / 100).toFixed(2);
    const fmt = cfg.money || '${{amount}}';
    return fmt.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, v.replace(/\B(?=(\d{3})+(?!\d))/g, ','));
  };
  const esc = (s) => String(s ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);
  const img = (url, w = 160) => (url ? url.replace(/(\.[a-z]+)(\?|$)/i, `_${w}x$1$2`) : '');

  async function api(path, body) {
    const res = await fetch(path, {
      method: body ? 'POST' : 'GET',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: body ? JSON.stringify(body) : undefined,
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) throw Object.assign(new Error(data.description || data.message || 'Cart error'), { data });
    return data;
  }

  function updateBubbles(count) {
    document.querySelectorAll('[data-ls-count], .cart-bubble__text-count, .cart-count').forEach((el) => {
      el.textContent = count;
    });
    document.querySelectorAll('.cart-bubble').forEach((el) => el.classList.toggle('visually-hidden', count === 0));
    document.querySelectorAll('cart-icon, .header-actions__cart-icon').forEach((el) => el.classList.toggle('header-actions__cart-icon--has-cart', count > 0));
  }

  function render(c) {
    if (!c) return;
    cart = c;
    const items = c.items || [];
    const visible = items.filter((i) => !hidden.has(Number(i.variant_id)));
    const count = visible.reduce((n, i) => n + i.quantity, 0);
    root.classList.toggle('is-empty', visible.length === 0);
    emptyEl.hidden = visible.length !== 0;
    countEl.textContent = count ? `(${count})` : '';
    linesEl.innerHTML = visible
      .map((i) => {
        const compare = (i.original_line_price > i.final_line_price && i.original_line_price) ||
          (i.variant_compare_at_price ? 0 : 0);
        const variant = i.variant_title && i.variant_title !== 'Default Title' ? `<span class="ls-cart__lv">${esc(i.variant_title)}</span>` : '';
        const free = i.final_line_price === 0 ? '<span class="ls-cart__lv">FREE BONUS</span>' : '';
        return `<li class="ls-cart__line" data-key="${esc(i.key)}">
          <img src="${esc((cfg.leads && cfg.leads[i.product_id]) || img(i.image))}" alt="" width="72" height="72" loading="lazy">
          <div><a class="ls-cart__lt" href="${esc(i.url)}">${esc(i.product_title)}</a>${variant}${free}
            <div><span class="ls-cart__qty"><button type="button" data-ls-q="-1" aria-label="Decrease">&minus;</button><span>${i.quantity}</span><button type="button" data-ls-q="1" aria-label="Increase">+</button></span><button type="button" class="ls-cart__rm" data-ls-rm>Remove</button></div>
          </div>
          <div class="ls-cart__lp">${i.final_line_price === 0 ? 'FREE' : money(i.final_line_price)}${compare ? `<s>${money(compare)}</s>` : ''}</div>
        </li>`;
      })
      .join('');
    totalEl.textContent = money(c.total_price);

    // savings vs compare at price, read from the line data attached by the theme
    const saving = visible.reduce((s, i) => s + Math.max(0, ((i.properties && Number(i.properties._compare)) || 0) * i.quantity - i.final_line_price), 0) + (c.total_discount || 0);
    saveWrap.hidden = !(saving > 0);
    if (saving > 0) saveEl.textContent = money(saving);

    if (total2) total2.textContent = money(c.total_price);
    if (ups) {
      const inCart = new Set(items.map((i) => Number(i.product_id)));
      let shown = 0;
      ups.querySelectorAll('[data-ls-up]').forEach((el) => {
        const show = visible.length > 0 && !inCart.has(Number(el.dataset.product)) && shown < MAX_UPS;
        el.hidden = !show;
        if (show) shown++;
      });
      ups.hidden = shown === 0;
    }
    if (spToggle) spToggle.checked = items.some((i) => Number(i.variant_id) === Number(cfg.protection));
    updateBubbles(count);
  }

  async function refresh() {
    render(await api('/cart.js'));
  }

  function open() {
    root.classList.add('is-open');
    root.setAttribute('aria-hidden', 'false');
    document.body.classList.add('ls-cart-lock');
    $('.ls-cart__panel').focus({ preventScroll: true });
  }
  function close() {
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('ls-cart-lock');
  }

  // Optimistic line shown the instant the button is pressed
  function pendingLine(info) {
    if (!info || !info.title) return;
    emptyEl.hidden = true;
    root.classList.remove('is-empty');
    const li = document.createElement('li');
    li.className = 'ls-cart__line is-busy';
    li.innerHTML = `<img src="${esc(info.image || '')}" alt="" width="72" height="72"><div><span class="ls-cart__lt">${esc(info.title)}</span>${info.variant ? `<span class="ls-cart__lv">${esc(info.variant)}</span>` : ''}<span class="ls-cart__lv">Adding…</span></div><div class="ls-cart__lp">${esc(info.price || '')}</div>`;
    linesEl.prepend(li);
  }

  async function add(items, info) {
    pendingLine(info);
    open();
    try {
      await api('/cart/add.js', { items });
      await refresh();
      return true;
    } catch (e) {
      await refresh().catch(() => {});
      alert(e.message);
      return false;
    }
  }

  async function change(key, quantity, lineEl) {
    if (busy) return;
    busy = true;
    lineEl && lineEl.classList.add('is-busy');
    try {
      let c = await api('/cart/change.js', { id: key, quantity });
      // drop protection when nothing else is left
      const rest = (c.items || []).filter((i) => !hidden.has(Number(i.variant_id)));
      const sp = (c.items || []).find((i) => Number(i.variant_id) === Number(cfg.protection));
      if (!rest.length && sp) c = await api('/cart/change.js', { id: sp.key, quantity: 0 });
      render(c);
    } catch (e) {
      await refresh();
    } finally {
      busy = false;
    }
  }

  root.addEventListener('click', (e) => {
    const t = e.target;
    if (t.closest('[data-ls-cart-close]')) return close();
    const line = t.closest('.ls-cart__line');
    if (line && t.closest('[data-ls-q]')) {
      const item = cart.items.find((i) => i.key === line.dataset.key);
      return change(line.dataset.key, Math.max(0, item.quantity + Number(t.closest('[data-ls-q]').dataset.lsQ)), line);
    }
    if (line && t.closest('[data-ls-rm]')) return change(line.dataset.key, 0, line);
    if (t.closest('[data-ls-up-add]')) {
      const b = t.closest('[data-ls-up-add]');
      const row = b.closest('[data-ls-up]');
      const sel = row.querySelector('[data-ls-up-v]');
      b.disabled = true;
      b.textContent = 'Adding…';
      const cmpCents = (sel.selectedOptions ? sel.selectedOptions[0] : sel).dataset.cmpCents || 0;
      add([{ id: Number(sel.value), quantity: 1, properties: { _upsell: 'cart', _compare: String(cmpCents) } }]).finally(() => {
        b.disabled = false;
        b.textContent = '+ Add';
      });
    }
  });

  root.addEventListener('change', (e) => {
    const sel = e.target.closest('select[data-ls-up-v]');
    if (!sel) return;
    const o = sel.selectedOptions[0];
    sel.closest('[data-ls-up]').querySelector('[data-ls-up-price]').innerHTML = o.dataset.price + (o.dataset.cmp ? ` <s>${o.dataset.cmp}</s>` : '');
  });

  spToggle &&
    spToggle.addEventListener('change', async () => {
      const sp = cart.items.find((i) => Number(i.variant_id) === Number(cfg.protection));
      if (spToggle.checked && !sp) {
        render(await api('/cart/add.js', { items: [{ id: Number(cfg.protection), quantity: 1 }] }).then(() => api('/cart.js')));
      } else if (!spToggle.checked && sp) {
        render(await api('/cart/change.js', { id: sp.key, quantity: 0 }));
      }
    });

  document.addEventListener('keydown', (e) => e.key === 'Escape' && root.classList.contains('is-open') && close());

  // Open from header cart icons / any cart link (capture so theme handlers don't navigate)
  document.addEventListener(
    'click',
    (e) => {
      const a = e.target.closest('a[href="/cart"], a[href$="/cart"], [data-ls-cart-open], .header-actions__cart-icon, cart-icon button');
      if (!a || root.contains(a)) return;
      e.preventDefault();
      e.stopPropagation();
      open();
      refresh();
    },
    true
  );

  // LickSticks product forms: <form data-ls-add> with name="id" (+ optional data-ls-extra JSON of extra items)
  document.addEventListener('submit', (e) => {
    const form = e.target.closest('form[data-ls-add]');
    if (!form) return;
    e.preventDefault();
    const fd = new FormData(form);
    const id = Number(fd.get('id'));
    const qty = Number(fd.get('quantity') || 1);
    const props = {};
    for (const [k, v] of fd.entries()) {
      const m = k.match(/^properties\[(.+)\]$/);
      if (m && v) props[m[1]] = v;
    }
    const items = [{ id, quantity: qty, properties: props }];
    try {
      JSON.parse(form.dataset.lsExtra || '[]').forEach((x) => items.push(x));
    } catch (_) {}
    const btn = form.querySelector('[type="submit"]');
    btn && (btn.disabled = true);
    add(items, {
      title: form.dataset.title,
      variant: form.dataset.variantTitle,
      image: form.dataset.image,
      price: form.dataset.price,
    }).finally(() => btn && (btn.disabled = false));
  });

  // Horizon / other theme forms (quick add etc.) – refresh and open after their add completes
  document.addEventListener('cart:update', () => {
    refresh().then(open);
  });

  window.LSCart = { open, close, refresh, add };
  if (cart) render(cart);
})();
